var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head w-100"},[_c('h2',[_vm._v("如何定制数据")]),_c('h3',[_vm._v("How to customize data")])])}]

export { render, staticRenderFns }